module.exports = {"230128100":"通河镇","230128101":"乌鸦泡镇","230128102":"清河镇","230128103":"浓河镇","230128104":"凤山镇","230128105":"祥顺镇","230128106":"富林镇","230128107":"三站镇","230128400":"清河林业局","230128401":"兴隆林业局","230128500":"岔林河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230128.json
// module id = 686
// module chunks = 0